/*
  Welcher zugeklappte Kasten eine Aufgabe verbirgt. Zugeklappt steht sie weder in der Liste noch in
  der Navigation — ein Sprung zu ihr (etwa aus „Favoriten“, #210) fände nichts zum Auswählen.
*/

interface SectionLike {
  id: string
  collapsed?: boolean
  archivedAt?: Date | null
}

/** Projekt: der zugeklappte Abschnitt der Aufgabe, sonst `null`. Archivierte Abschnitte klappen anders. */
export function collapsedSectionOf(
  taskId: string,
  tasks: readonly { id: string; sectionId?: string | null }[] | undefined,
  sections: readonly SectionLike[] | undefined,
): string | null {
  const sectionId = tasks?.find(task => task.id === taskId)?.sectionId
  if (!sectionId) return null
  const section = sections?.find(item => item.id === sectionId)
  return section?.collapsed && !section.archivedAt ? section.id : null
}

/** Kurz notiert: das zugeklappte Zeitfenster („Letzte 7 Tage“ / „Älter“), in dem die Aufgabe liegt. */
export function collapsedSegmentOf(
  taskId: string,
  segments: readonly { section: { id: string } | null; collapsed?: boolean; allTasks?: readonly { id: string }[] }[],
): string | null {
  const segment = segments.find(item => item.collapsed && item.allTasks?.some(task => task.id === taskId))
  return segment?.section?.id ?? null
}
